import moment from "moment";
import { CATEGORIAS_ACOPIO } from "./constants";

/**
 * Función para redondear un número a una cantidad específica de decimales
 * @param {number} num
 * @param {number} decimales
 * @returns {number}
 */
export const redondearDecimales = (num, decimales = 4) => {
    const factor = Math.pow(10, decimales);
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

/**
 * Obtiene el mensaje de error desde una respuesta de API
 * @param {*} error
 * @param {string} defaultMessage
 * @returns {string}
 */
export const getErrorFromResponse = (
    error,
    defaultMessage = "Ocurrió un error",
) => {
    if (!error) return defaultMessage;

    if (typeof error === "string") return error;

    if (error.detail) return error.detail;

    return defaultMessage;
};

/**
 * Convierte una fecha a la hora de inicio del día
 * @param {*} date - fecha a convertir
 * @returns {string|null} - fecha convertida o null si no se proporciona una fecha válida
 */
export const dateToDayStart = (date) => {
    if (!date) return null;

    const newDate = moment(date).startOf("day").format("YYYY-MM-DD HH:mm:ss");

    return newDate;
};

/**
 * Convierte una fecha a la hora final del día
 * @param {*} date - fecha a convertir
 * @returns {string|null} - fecha convertida o null si no se proporciona una fecha válida
 */
export const dateToDayEnd = (date) => {
    if (!date) return null;

    const newDate = moment(date).endOf("day").format("YYYY-MM-DD HH:mm:ss");

    return newDate;
};

/**
 * Formatea un número con un mínimo de dígitos
 * @param {*} num - número a formatear
 * @param {*} minDigits - cantidad mínima de dígitos (por defecto 5)
 * @returns {string} - número formateado con ceros a la izquierda si es necesario
 */
export const formatWithMinDigits = (num, minDigits = 5) => {
    const str = String(num);
    return str.length >= minDigits ? str : str.padStart(minDigits, "0");
};

/**
 * Función para retornar un número formateado con separadores de miles y decimales
 * @param {number} value - El número a formatear
 * @param {number} decimals - Cantidad de decimales a mostrar (opcional, por defecto 0)
 * @returns {string} - Número formateado
 */
export const formatDisplayNumber = (value, decimals = 0, truncate = false) => {
    if (!value) return "0";

    let formattedValue = value;

    if (truncate && decimals >= 0) {
        const factor = Math.pow(10, decimals);
        formattedValue = Math.trunc(value * factor) / factor;
    }

    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(formattedValue);
};

/**
 * Obtiene el nombre del acopio del usuario
 * @param {*} user - usuario en sesión
 * @returns {string} - nombre del acopio, o "Planta ERSA" si el usuario no tiene acopio
 */
export const getNombreAcopio = (user) => {
    if (!user || !user.acopio || !user.acopio.nombre) return "Planta ERSA";

    return user.acopio.nombre;
};

/**
 * Obtiene la categoría del acopio del usuario
 * @param {*} user - usuario en sesión
 * @returns {string} - categoría del acopio, o PLANTA si el usuario no tiene acopio
 */
export const getCategoriaAcopio = (user) => {
    if (!user || !user.acopio) return CATEGORIAS_ACOPIO.PLANTA;

    return user.acopio.categoria;
};
